import { render, staticRenderFns } from "./SecretEditor.vue?vue&type=template&id=6353f398&scoped=true"
import script from "./SecretEditor.vue?vue&type=script&lang=js"
export * from "./SecretEditor.vue?vue&type=script&lang=js"
import style0 from "./SecretEditor.vue?vue&type=style&index=0&id=6353f398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6353f398",
  null
  
)

export default component.exports